module.exports = __webpack_public_path__ + "assets/qingjia2.46c6e417.svg";